<template>
  <splash-screen v-if="isLoading" />
  <!-- Default Layout -->
  <div v-else class="antialiased text-gray-900 bg-white">
    <div class="flex h-screen overflow-y-hidden bg-white">
      <side-bar
        :isSidebarOpen="isSidebarOpen"
        @toggle-sidebar="toggleSidebar"
        @logout="onLogout"
      />
      <div class="flex flex-col flex-1 h-full overflow-hidden">
        <header-bar
          :isOpen="false"
          @toggle-is-open="toggleSidebar"
          @toggle-sidebar="toggleSidebar"
        />
        <!-- Main content -->
        <main class="flex-1 max-h-full p-5 overflow-hidden overflow-y-scroll">
          <slot />
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted } from "vue";

import { ActionTypes, useStore } from "store";

import { HeaderBar, SideBar } from "components/molecules";
import SplashScreen from "components/templates/SplashScreen.vue";

export default {
  name: "DefaultLayout",
  components: { HeaderBar, SideBar, SplashScreen },
  setup() {
    const store = useStore();
    const isSidebarOpen = computed(() => store.state.ui.isSideBarOpen);
    const isLoading = computed(() => store.state.ui.isGeneralLoaderOn);

    onMounted(() => {
      if (store.getters.isUserLoggedIn)
        store.dispatch(ActionTypes.INIT_UI_MODULE, undefined);
    });

    const toggleSidebar = () => store.dispatch(ActionTypes.TOGGLE_SIDEBAR);

    const onLogout = () => store.dispatch(ActionTypes.LOGOUT);

    return {
      isSidebarOpen,
      toggleSidebar,
      onLogout,
      isLoading,
    };
  },
};
</script>